export default __webpack_public_path__ + "static/media/phoneIcon.adb04dea.svg";